import VideoWidget from "./VideoWidget";

export default VideoWidget;